<bwh-lib-step-control-bar
  [langDropdown]="true"
  [prevBut]="prevBut"
  [closeBut]="closeBut"
  [currentStep]="wizardService?.currentStep"
  [previousStep]="wizardService?.previousStep"
  [steps]="wizardService?.totalSteps"
  (emitClose)="close()"
  (emitPrev)="goPrev()"
></bwh-lib-step-control-bar>
<div class="text-center step-wrapper">
  <ng-container *ngIf="dataLoaded">
    <p *ngIf="professionGroups.length === 0" class="no-professions-message">
      {{ 'global.no_professions_found' | translate }}
    </p>

    <ng-container *ngIf="currentGroup">
      <div class="main-header">
        <h1 class="main-title mb-3">
          {{ 'global.profession_skills_title' | translate: { profession: currentGroup.professionName } }}
        </h1>
      </div>
      <p class="main-description mb-5">{{ 'global.profession_skills_description' | translate }}</p>
    </ng-container>
  </ng-container>

  <div class="scrollable-content">
    <div *ngIf="dataLoaded" [formGroup]="form">
      <ng-container *ngIf="currentGroup">
        <div class="loading-spinner" *ngIf="!currentGroup.loaded">
          <mat-spinner [diameter]="30"></mat-spinner>
        </div>

        <div class="profession-skills-checkboxes" *ngIf="currentGroup.loaded">
          <div
            class="skill-checkbox-tile"
            *ngFor="let skill of currentGroup.skills"
            (click)="toggleSkill(skill)"
            [class.selected]="isSkillAdded(skill)"
          >
            <mat-checkbox
              [checked]="isSkillAdded(skill)"
              (change)="toggleSkill(skill)"
              (click)="$event.stopPropagation()"
              color="primary"
            >
              {{ skill.text }}
            </mat-checkbox>
          </div>
          <p *ngIf="currentGroup.skills.length === 0" class="no-skills-message">
            {{ 'global.no_profession_skills_available' | translate }}
          </p>
        </div>
      </ng-container>

      <ul class="next-button-container">
        <li *ngIf="prevBut === true">
          <button class="btn w-md h-lg primary prev-btn" type="button" (click)="goPrev()">
            {{ 'global.previous' | translate }}
          </button>
        </li>
        <li *ngIf="!prevBut && !closeBut">
          <button class="btn w-md h-lg primary" type="button" (click)="emitClose.emit('cancelled')">
            {{ 'global.cancel' | translate }}
          </button>
        </li>
        <li>
          <button class="btn w-md h-lg secondary" type="button" (click)="onSubmit()">
            {{ 'global.next_button' | translate }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</div>
